import { Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { ItemListResponse, Label, LabelType, searchResource } from '@models';
import { environment } from '@environment';
import { form, FormField, submit } from '@angular/forms/signals';
import { MatSelectModule } from '@angular/material/select';
import { FormControlAutocompleteComponent } from '@components/form-control/autocomplete/autocomplete.component';

@Component({
  selector: 'app-dataset-form-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
  imports: [
    FormField,

    MatDialogModule,
    MatButtonModule,
    MatSelectModule,

    FormControlAutocompleteComponent,
  ],
})
export class DatasetFormLabelComponent {
  dialogRef =
    inject<MatDialogRef<DatasetFormLabelComponent>>(MatDialogRef);

  form = form(signal({
    labelType: LabelType.Harvester,
    labels: [] as string[],
  }));

  labelSearch = signal('');
  labelDisplayWith = (l: Label) => `${l.type}: ${l.title}`
  labelResource = searchResource<Label[]>(
    () =>
      `${environment.kinkoHost}/label/?type=${this.form.labelType().value()}&order=title&take=10&q=${this.labelSearch()}`,
    300,
    {
      parse: (resp) => (resp as ItemListResponse<Label>).items
    },
  );

  save(event: Event) {
    event.preventDefault()

    submit(this.form, async () => {
      this.dialogRef.close(this.form.labels().value());
    });
  }
}
